<template>
  <span class="badge badge-pill badge-primary"
    >{{ prefix }} {{ teamName }}</span
  >
</template>
<script>
export default {
  name: "TeamBadge",
  props: {
    teamName: {},
    prefix: { default: "as" }
  }
};
</script>
